import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';

export const buildAccordionFaqGrid03 = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;
  const heading = suggestionFields?.content?.heading || '';
  const subheading = suggestionFields?.content?.subheading || '';

  const listItem = (suggestionFields?.content?.faq_items || []).map(item => {
    return {
      question: item.question || '',
      answer: item.answer || '',
    };
  });

  const fieldUpdate = {
    title: 'Accordion FAQ Grid 03',
    titleFaq: `
            <h2>${heading || ''}</h2>
            <p>${subheading || ''}</p>
        `,
    color: {
      backgroundContainer: '',
      backgroundFaqItem: '',
      textFaqItem: '',
    },
    listItem,
    topPadding: true,
    bottomPadding: true,
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionFaqGrid03(newSection.html, fieldUpdate),
  };
};
export const buildAccordionFaqGrid04 = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;
  const heading = suggestionFields?.content?.heading || '';
  const subheading = suggestionFields?.content?.subheading || '';

  const listItem = (suggestionFields?.content?.faq_items || []).map(item => {
    return {
      question: item.question || '',
      answer: item.answer || '',
    };
  });

  const fieldUpdate = {
    title: 'Accordion FAQ Grid 04',
    titleFaq: `
            <h2>${heading || ''}</h2>
            <p>${subheading || ''}</p>
        `,
    color: {
      backgroundContainer: '',
      backgroundFaqItem: '',
      textFaqItem: '',
      borderFaqItem: '',
    },
    listItem,
    topPadding: true,
    bottomPadding: true,
  };

  return {
    ...newSection,
    html: updateHtmlFromData.sectionFaqGrid04(newSection.html, fieldUpdate),
  };
};
